import MessagePanelContents from "./message-panel-contents";

export default MessagePanelContents;
